import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { useAppDispatch, useAppSelector } from "../../../_app";
import { PayrollService } from "../../../_service";
import { Notify, Utils } from "../../../utils";
import {
  CustomDateField,
  CustomSelectField,
  CustomeCkeckboxField,
} from "../../../components/customFormField";
import { CustomButton } from "../../../components/customButton";
import { FormErrorMessage } from "../../../components";
import { Constant } from "../../../config";
import { Table, TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import { updateCurrentEmployee } from "../../../_features/employee";
import moment from "moment";

const ManageEndService = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const employee = useAppSelector((state) => state.employee.employee_info);
  const companyId = useAppSelector((state) => state.user.defaultCompnayId);
  const currentEmployee = useAppSelector((state) => state.employee.currentEmployee);

  const [reasons, setReasons] = useState([]);
  const [historyData, setHistoryData] = useState([]);

  const [reason, setReason] = useState("");
  const [lastDayOfService, setLastDayOfService] = useState();
  const [requireFormIr21, setRequireFormIr21] = useState<boolean>(false);
  const [eosId, setEosId] = useState<any>(null)

  const [errorCollection, setErrorCollection] = useState<any>({});
  const updateErrorByKey = (key: string, val?: string) => {
    if (val) {
      setErrorCollection((prev: any) => ({ ...prev, [key]: val || "" }));
      return;
    }
    delete errorCollection[key];
    setErrorCollection(errorCollection);
  };
  const handleDataUpdate = async () => {
    try {
      if (!lastDayOfService) {
        updateErrorByKey("last_day_of_service", "can't be empty");
        return;
      }
      if (reason === "") {
        updateErrorByKey("reason_for_termination", "can't be empty");
        return;
      }
      setErrorCollection({});
      const data = {
        employee: employee.id,
        company: companyId,
        end_service_reason: reason,
        last_date_of_service: Utils._date(lastDayOfService),
        require_form_ir21: requireFormIr21,
      };
      const res = await PayrollService._updateEndService(data);
      if (res.status === 200) {
        Notify("End Service updated successfully", 1);
        handleNavigateBack();
      }
    } catch (e: any) {
      Utils.showErrorMessage(e);
    }
  };

  const handleNavigateBack = () => {
    navigate("/dashboard/payroll/emp");
  };
  // const get = async () => {
  //   try {
  //     const { data } = await PayrollService._getEndServiceReasons();
  //     setReasons(() => data.data);
  //   } catch (e: any) {
  //     if (e.response.status === 401) {
  //       // disaptch(resetUser());
  //     }
  //   }
  // };

  const getEndServiceDetails = async () => {
    try {
      const { data, status } = await PayrollService._getEndService({
        employee: employee.id,
        companyId,
      });

      if (status >= 200 && status < 300) {
        if (data.data?.end_service_reason) {
          setLastDayOfService(() => data.data.last_date_of_service);
          setEosId(data?.data?.id);
        }
        // console.log('ManageRome', data.data)
        dispatch(
          updateCurrentEmployee({
            currentEmployee: {
              ...currentEmployee,
              eos: {...data.data},
            },
          })
        );
      }
    } catch (error:any) {
      Utils.showErrorMessage(error);
      
    }
  };

  const getServicePeriodHistory = async () => {
    try {
      const { data, status } = await PayrollService._getServicePeriodHistory({
        employee: employee.id,
        companyId,
      });

      if (status >= 200 && status < 300) {
        setHistoryData(data?.data);
      }
    } catch (error:any) {
      Utils.showErrorMessage(error)
    }
  };

  const handleUndoTermination = async () => {
    try {
      const {status} = await PayrollService._undoTermination(eosId);
      if(status >= 200 && status < 300){
        Notify("Termination Cancelled",1);
        dispatch(
          updateCurrentEmployee({
            currentEmployee: {
              ...currentEmployee,
              eos: null,
            },
          })
        )
        // navigate("/dashboard/payroll/emp")
        navigate("/dashboard/employee-payroll")
        
      }
    } catch (error:any){
      Utils.showErrorMessage(error);
    }
  }

  const handleReinstate = async (date: string) => {
    let payload = {
        "employee_id": employee.id,
        "date": date
    }
    try {
      const {status} = await PayrollService._reinstateEmployee(payload);
      if(status >= 200 && status < 300){
        Notify("Employee Reinstated",1);
        dispatch(
          updateCurrentEmployee({
            currentEmployee: {
              ...currentEmployee,
              eos: null,
            },
          })
        )
        navigate("/dashboard/payroll/emp")
        // navigate("/dashboard/employee-payroll")
      }
    } catch (error:any){
      Utils.showErrorMessage(error);
    }
  }

  useEffect(() => {
    // get();
    getEndServiceDetails();
    getServicePeriodHistory();
  }, []);

  const listItems = [
    {
      id: 'cancel',
      title: 'Cancel / Undo Termination',
      content: 'This will remove all records of the termination and allow you to continue with payslips for the employee as normal.'
    },
    {
      id: 'update',
      title: 'Update Termination Date / Reason',
      content: 'Allows you to adjust this information if needed.'
    },
    {
      id: 'reinstate',
      title: 'Re-instate the Employee',
      content: 'Use this option if an employee was in fact previously terminated, but is now being employed again. The system will record a new service period for the employee and will ask you for a new appointment date. You should also use this for employees returning from long-term absences during which they were still employed.'
    }
  ];


  return (
    <div style={{ marginTop: "2rem",  }}>
      <div style={{marginBottom: '3rem'}}>
        <p style={{marginBottom:'1rem'}}>
         { `The employee's last day of service is ${lastDayOfService || ""}. You have the
          following options available:`}
        </p>

        <ul style={{marginLeft: '1.5rem'}}>
          {listItems.map((item, index) => (
            <li key={index} style={{marginBottom: '0.5rem'}}>
              <p onClick={()=>{
                if (item?.id === 'cancel') {
                  handleUndoTermination();
                }
                if (item?.id === 'update') {
                  navigate("/dashboard/payroll/end-service")
                }
                if (item?.id === 'reinstate') {
                  // to be done
                  navigate("/dashboard/reinstate-employee")
                }
              }} style={{color: `${"#059bbf"}`, fontWeight: 'bold', cursor: `${"pointer"}`}}>{item.title}</p>
              <p>{item.content}</p>
            </li>
          ))}
        </ul>
      </div>

      {/* info text */}
      <div style={{ border: "1px solid rgb(5, 155, 191)",borderRadius: '0.5rem', padding: "1rem 1rem", display: 'flex', flexDirection: 'column', gap: '0.5rem', width: 'fit-content', marginBottom: '1rem' }}>
        <p style={{ fontSize: '1.15rem', fontWeight: 700, color: 'rgb(5, 155, 191)' }}>
          How do we find the record of this employee's terminated record in the system:
        </p>
        <p>1. Admin goes to <em>"Manage Employee"</em> form.</p>
        <p>2. Enter the employee's name in the search bar.</p>
        <p>3. On the <em>"Employee terminated record"</em>, click the <em>"End Service"</em> tab.</p>
        <p>4. The form opens showing <em>"Re-instate the Employee"</em> option.</p>
        <p>5. Admin selects the <em>"Re-instate the employee"</em> link and enters the new joined date and <em>Save</em>.</p>
        <p>6. System default probation month count is <strong>Zero</strong> </p>
      </div>


      <p style={{fontSize: '1.75rem', color: '#476575', fontWeight: 600, marginBottom: '0.5rem'}}>Service Period History</p>
      
      <Table size="small" aria-label="full width table">
      <TableHead>
        <TableRow>
          <TableCell align="left" colSpan={1} sx={{fontWeight: 'bold', fontSize:  '1rem', padding:'0.8rem'}}>Service Period</TableCell>
          <TableCell align="left" colSpan={1} sx={{fontWeight: 'bold', fontSize:  '1rem', padding:'0.8rem'}}>Form Requirements</TableCell>
          <TableCell align="center" colSpan={1} sx={{fontWeight: 'bold', fontSize:  '1rem', padding:'0.8rem'}}>Actions</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {historyData?.length > 0 && historyData?.map((item:any) => <TableRow>
          <TableCell sx={{padding:'0.8rem', fontSize:  '1rem'}} align="left">{`From ${item?.service_start_date ? moment(item?.service_start_date).format("DD-MM-YYYY") : ""} ${item?.service_end_date ? 'to' : ""} ${
                            item?.service_end_date ? moment(item?.service_end_date).format("DD-MM-YYYY") : ` till now`
                          }`}</TableCell>
          <TableCell sx={{padding:'0.8rem', fontSize:  '1rem'}} align="left">{item?.require_form_ir21 ? "Form IR21 Required": "Form IR21 Not Required"}</TableCell>
          <TableCell sx={{padding:'0.8rem', fontSize:  '1rem'}} align="center"> {` —`} </TableCell>
        </TableRow>)}
        
      </TableBody>
    </Table>
      
    </div>
  );
};

export default ManageEndService;
